"use client";

import _defineProperty from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { createHovercardStore } from "../__chunks/EACLTACN.js";
import { createCompositeStore } from "../__chunks/IJ6VFLJG.js";
import "../__chunks/7DTP4AQO.js";
import "../__chunks/7PRQYBBV.js";
import "../__chunks/3UYWTADI.js";
import "../__chunks/YOHCVXJB.js";
import "../__chunks/6E4KKOSB.js";
import { createStore, mergeStore, omit, pick, setup, sync, throwOnConflictingProps } from "../__chunks/EQQLU3CG.js";
import { applyState, defaultValue } from "../__chunks/PBFD2E7P.js";
import "../__chunks/PQP5VPTV.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-store.ts
function createMenuStore() {
  var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _b = _a,
    combobox = _b.combobox,
    parent = _b.parent,
    menubar = _b.menubar,
    props = __objRest(_b, ["combobox", "parent", "menubar"]);
  var parentIsMenubar = !!menubar && !parent;
  var store = mergeStore(props.store, pick(parent, ["values"]), omit(combobox, ["arrowElement", "anchorElement", "contentElement", "popoverElement", "disclosureElement"]));
  throwOnConflictingProps(props, store);
  var syncState = store.getState();
  var composite = createCompositeStore(__spreadProps(__spreadValues({}, props), {
    store: store,
    orientation: defaultValue(props.orientation, syncState.orientation, "vertical")
  }));
  var hovercard = createHovercardStore(__spreadProps(__spreadValues({}, props), {
    store: store,
    placement: defaultValue(props.placement, syncState.placement, "bottom-start"),
    timeout: defaultValue(props.timeout, syncState.timeout, parentIsMenubar ? 0 : 150),
    hideTimeout: defaultValue(props.hideTimeout, syncState.hideTimeout, 0)
  }));
  var initialState = __spreadProps(__spreadValues(__spreadValues({}, composite.getState()), hovercard.getState()), {
    initialFocus: defaultValue(syncState.initialFocus, "container"),
    values: defaultValue(props.values, syncState.values, props.defaultValues, {})
  });
  var menu = createStore(initialState, composite, hovercard, store);
  setup(menu, function () {
    return sync(menu, ["mounted"], function (state) {
      if (state.mounted) return;
      menu.setState("activeId", null);
    });
  });
  setup(menu, function () {
    return sync(parent, ["orientation"], function (state) {
      menu.setState("placement", state.orientation === "vertical" ? "right-start" : "bottom-start");
    });
  });
  return __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, composite), hovercard), menu), {
    combobox: combobox,
    parent: parent,
    menubar: menubar,
    hideAll: function hideAll() {
      hovercard.hide();
      parent == null ? void 0 : parent.hideAll();
    },
    setInitialFocus: function setInitialFocus(value) {
      return menu.setState("initialFocus", value);
    },
    setValues: function setValues(values) {
      return menu.setState("values", values);
    },
    setValue: function setValue(name, value) {
      if (name === "__proto__") return;
      if (name === "constructor") return;
      if (Array.isArray(name)) return;
      menu.setState("values", function (values) {
        var prevValue = values[name];
        var nextValue = applyState(value, prevValue);
        if (nextValue === prevValue) return values;
        return __spreadProps(__spreadValues({}, values), _defineProperty({}, name, nextValue !== void 0 && nextValue));
      });
    }
  });
}
export { createMenuStore };